import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

export const dataStore = defineStore('data', {
  /* Current State */
  state: () => ({
    locations: [],
    users: [],
    loading: {
      locations: false,
      users: false,
      systemCalibrations: false
    },
    csvData: [],
    csvValidation: [],
    systemCalibrations: []
  }),
  actions: {
    resetCsvData() {
      this.csvData = []
      this.csvValidation = []
    },
    setCsvData(type, data) {
      if (data) {
        if (data.length > 0) {
          if (type === 'locations') {
            let hierarchy = [
              {
                name: 'Corporate',
                value: 1
              },
              {
                name: 'Region',
                value: 2
              },
              {
                name: 'Division',
                value: 3
              },
              {
                name: 'Branch',
                value: 4
              },
              {
                name: 'Team',
                value: 5
              },
              {
                name: 'Agent',
                value: 6
              }
            ]
            var parents = [
              ...new Map(
                data.map((item) => [
                  item['parentName'],
                  {
                    name: item.parentName,
                    level: hierarchy.map((e) => e.name).indexOf(item.firmTypeName)
                  }
                ])
              ).values()
            ].filter((x) => x.level !== 0)
            var firmsAsParents = data
              .map((item, idx) => {
                return {
                  name: item.firmName,
                  level: hierarchy.find((e) => e.name === item.firmTypeName).value,
                  idx
                }
              })
              .filter((x) => x.level !== 6)

            let differences = firmsAsParents.filter((x) => !parents.some((y) => y.name === x.name))
            console.log('Differences', differences)
            this.csvData = data
          } else {
            this.csvData = data
          }
          console.log('Got CSV data', this.csvData)
        }
      }
    },
    async getLocationsForExport(firm) {
      this.locations = []
      this.loading.locations = true
      this.locations = await api.get(`data/firms?firm=${firm}`)
      this.loading.locations = false
      console.log('Got Locations', this.locations)
      return this.locations
    },
    async getUsersForExport(firm) {
      this.users = []
      this.loading.users = true
      this.users = await api.get(`data/users?firm=${firm}`)
      this.loading.users = false
      console.log('Got Users', this.users)
      return this.users
    },
    async importMembers(parentBranch) {
      console.log('Importing Members', {
        parentBranch: parentBranch,
        csvData: this.csvData
      })
      return await api.post(`data/importMembers?parentBranch=${parentBranch}`, this.csvData)
    },
    async importLocations(parentBranch) {
      console.log('Importing Locations', {
        parentBranch: parentBranch,
        csvData: this.csvData
      })
      return await api.post(`data/importFirms?parentBranch=${parentBranch}`, this.csvData)
    },
    async importUsers() {
      console.log('Importing Users', this.csvData)
      return await api.post('data/importUsers', this.csvData)
    },
    async verifyCSV(data) {
      console.log('Verifying CSV data', data)
      return await api.post('data/verifyCSV', data)
    },
    resetCalibrations() {
      this.systemCalibrations = []
    },
    async deleteCalibration(data) {
      return await api.get(`data/removeCalibration?systemType=${data.systemType}&calibrationType=${data.calibrationType}`)
    },
    async getSystemCalibrations(systemType) {
      this.loading.systemCalibrations = true
      this.systemCalibrations = []
      let results = await api.get(`data/systemCalibrations?systemType=${systemType}`)
      if (results) {
        this.systemCalibrations = results
      }
      this.loading.systemCalibrations = false
    }
  }
})
